import React, { ReactNode } from 'react'
import { KabinetView } from './KabinetView'

interface IKabinetProps {
  rootUrl: string
  wsUrl: string
  children: ReactNode
}
interface IKabinetViewProps extends IKabinetProps {}

export type KabinetProps = IKabinetProps
export type KabinetViewProps = IKabinetViewProps

export const Kabinet = (props: KabinetProps): JSX.Element => {
  return (
    <KabinetView {...props}>
      {props.children}
    </KabinetView>
  )
}
